// Replay screen entry (REP-4). The thin launcher that opens the time-scrubber
// overlay on the live recording — either the whole thing or its last
// `REP_INSTANT_SECONDS` (instant replay). Kept separate from the overlay DOM so the
// menu/keybind surface can grow (a saved-replays list, imports) without touching the
// player. Returns whether a viewer was opened (false = nothing recorded yet).
import type { ReplayController } from '../../replay/controller';

export type ReplayLaunchMode = 'full' | 'instant';

/** Open the replay viewer on the current recording. */
export function openReplayScreen(controller: ReplayController, mode: ReplayLaunchMode = 'instant'): boolean {
  return mode === 'instant' ? controller.openInstantReplay() : controller.openViewer();
}
